<abp-page-toolbar-container class="col"> </abp-page-toolbar-container>

<div class="flex flex-wrap gap-2 mb-4">
  <div class="w-full md:w-[68%]">
    <div class="flex bg-white p-2 rounded flex-col !gap-2">
      <div *ngIf="parentAsset">
        <app-assets-parent-info [parent]="parentAsset" />
        <hr />
      </div>
      <div class="flex flex-wrap justify-between">
        <div class="flex items-center gap-1">
          <h3 class="text-base font-medium text-gray-90">
            {{ 'RegisterService::Asset:Summary' | abpLocalization }}
          </h3>
          <label class="form-label m-0 text-sm border-x px-1">
            {{ (asset.primaryIdPrefix ?? '') + asset.primaryID }}/{{ asset.secondaryID || '-' }}
          </label>

          <label class="form-label m-0 text-sm">
            {{ asset.categoryNickname }}
          </label>
        </div>
        <div class="flex w-full justify-between xs:w-fit gap-2">
          <div class="flex items-center !gap-2">
            <div class="rounded-full w-4 h-4 bg-[#FF495B33] flex flex-center">
              <div class="w-[6px] h-[6px] rounded-full bg-red"></div>
            </div>
            <div class="rounded-full w-4 h-4 bg-[#4DC34333] flex flex-center">
              <div class="w-[6px] h-[6px] rounded-full bg-green"></div>
            </div>
            <div class="rounded-full w-4 h-4 bg-[#4DC34333] flex flex-center">
              <div class="w-[6px] h-[6px] rounded-full bg-green"></div>
            </div>
            <div class="flex items-center justify-center">
              <i class="fa fa-wifi text-green-500"></i>
            </div>
          </div>
          <div *ngIf="!isPageTemporary && !asset?.parentId">
            <button
              *abpPermission="'RegisterService.Assets.Create'"
              class="btn btn-primary btn-sm"
              type="button"
              (click)="create()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i>
              {{ 'RegisterService::NewSubAsset' | abpLocalization }}
            </button>
          </div>
        </div>
      </div>

      <div class="flex flex-col !gap-2 !pb-2">
        <div class="flex flex-col xs:flex-row !gap-4 w-full">
          <app-asset-avatar
            [asset]="asset"
            [isPageTemporary]="isPageTemporary"
            [tenantPassword]="tenantPassword"
          />

          <div class="flex flex-col !gap-3 w-full">
            <div>
              <label class="form-label text-xs" for="asset-home-location-id">
                {{ 'RegisterService::HomeLocation' | abpLocalization }}
              </label>
              <input
                id="asset-home-location-id"
                [value]="asset?.homeLocationName ?? null"
                class="form-control bg-gray-30 !py-2"
                maxlength="64"
                readOnly
              />
              <!-- <img [src]="'assets/images/no-picture.jpg'" /> -->
            </div>
            <div>
              <label class="form-label text-xs" for="asset-secondary-location-id">
                {{ 'RegisterService::SecondaryLocation' | abpLocalization }}
              </label>
              <input
                id="asset-secondary-location-id"
                [value]="asset?.secondaryLocationName ?? null"
                class="form-control bg-gray-30 !py-2"
                maxlength="64"
                readOnly
              />
            </div>
            <div>
              <label class="form-label text-xs" for="asset-jobsite-id">
                {{ 'RegisterService::Jobsite' | abpLocalization }}
              </label>
              <input
                id="asset-jobsite-id"
                class="form-control bg-gray-30 !py-2"
                maxlength="64"
                readonly
                [value]="asset?.jobsiteNames?.join(', ') ?? null"
              />
            </div>
            <div>
              <label class="form-label text-xs" for="asset-home-location-id">
                {{ 'ServicingService::EventLocation' | abpLocalization }}
              </label>
              <input
                id="asset-home-location-id"
                [value]="asset?.targetLocationName ?? null"
                class="form-control bg-gray-30 !py-2"
                maxlength="64"
                readOnly
              />
            </div>
            <div class="flex !gap-3">
              <div class="flex justify-between w-full bg-gray-30 rounded p-2">
                <label class="text-xs text-gray">
                  {{ 'RegisterService::HrsKm' | abpLocalization }}
                </label>
                <label class="text-sm">
                  {{ asset.hours || '-' }}/{{ asset.kilometers || '-' }}
                </label>
              </div>
              <div
                class="flex justify-between p-2 rounded w-full"
                [ngStyle]="{
                  background:
                    asset.availability === 'AVAILABLE'
                      ? 'linear-gradient(270deg, #D5F7D2 0%, #F7F9FA 50.18%)'
                      : 'linear-gradient(270deg, #FFDBDE 0%, #F7F9FA 50.18%)'
                }"
              >
                <label class="text-xs text-gray">
                  {{ 'RegisterService::Availability' | abpLocalization }}
                </label>
                <label
                  ><p
                    class="text-sm font-medium"
                    [ngClass]="asset.availability === 'AVAILABLE' ? 'text-green' : 'text-red'"
                  >
                    {{
                      'RegisterService::' + formatAvailability(asset.availability) | abpLocalization
                    }}
                  </p></label
                >
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div class="flex !gap-3 w-full">
          <div class="w-full">
            <label class="form-label text-xs" for="asset-categoryFullName">
              {{ 'ServicingService::Category' | abpLocalization }}
            </label>
            <input
              id="asset-categoryFullName"
              [value]="asset?.categoryFullName ?? null"
              class="form-control bg-gray-30 !py-2"
              maxlength="64"
              readOnly
            />
          </div>
          <div class="w-full">
            <label class="form-label text-xs" for="asset-tracker-primary">
              {{ 'RegisterService::Tracker' | abpLocalization }}
            </label>
            <input
              placeholder="Trackers List"
              id="asset-tracker-primary"
              [value]="asset?.deviceNames?.join(', ') ?? null"
              class="form-control bg-gray-30 !py-2"
              maxlength="64"
              readonly
            />
          </div>
        </div>
        <div class="flex !gap-3 w-full">
          <div class="w-full">
            <label class="form-label text-xs" for="asset-standart-compliance">
              {{ 'RegisterService::StandardCompliance' | abpLocalization }}
            </label>
            <input
              id="asset-standart-compliance"
              [value]="ComplianceStatus[asset.standartComplianceStatus] || '-'"
              class="form-control bg-gray-30 !py-2"
              maxlength="64"
              readonly
            />
          </div>
          <div class="w-full">
            <label class="form-label text-xs" for="asset-jobsite-compliance">
              {{ 'RegisterService::JobsiteCompliance' | abpLocalization }}
            </label>
            <input
              id="asset-jobsite-compliance"
              [value]="ComplianceStatus[asset.jobsiteComplianceStatus] || '-'"
              class="form-control bg-gray-30 !py-2"
              maxlength="64"
              readonly
            />
          </div>
        </div>
        <hr />

        <div>
          <label class="form-label text-xs" for="asset-notes">
            {{ 'RegisterService::AssetNotes' | abpLocalization }}
          </label>
          <textarea
            id="asset-notes"
            [value]="asset?.notes ?? null"
            rows="1"
            class="form-control bg-gray-30"
            maxlength="5120"
            readonly
          ></textarea>
        </div>

        <div>
          <label class="form-label text-xs" for="asset-components">
            {{ 'RegisterService::Components' | abpLocalization }}
          </label>
          <textarea
            id="asset-components"
            [value]="asset?.components ?? null"
            rows="1"
            class="form-control bg-gray-30"
            maxlength="5120"
            readonly
          ></textarea>
        </div>
      </div>
    </div>

    <div class="bg-white rounded p-2 mt-2" *ngIf="inspections.items.length">
      <ngx-datatable
        [rows]="inspections.items"
        [count]="inspections.totalCount"
        [list]="list"
        default
      >
        <ngx-datatable-column [sortable]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.inspectionTypeName }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'ServicingService::Date' | abpLocalization }}" prop="doneOn">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.doneOn | date }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          [sortable]="false"
          name="{{ 'ServicingService::State' | abpLocalization }}"
          prop="state"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ 'ServicingService::' + row.state | abpLocalization }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          [sortable]="false"
          name="{{ 'ServicingService::ReportNumber' | abpLocalization }}"
          prop="siteName"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.reportNumber }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'ServicingService::DueOn' | abpLocalization }}" prop="dueOn">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.dueOn | date }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [sortable]="false">
          <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
            <button type="button" class="btn btn-light btn-sm" (click)="onView(row)">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
    <div class="mt-2">
      <app-current-events
        [asset]="asset"
        [isPageTemporary]="isPageTemporary"
        [isAssetDetailsPage]="true"
      />
    </div>
  </div>

  <div class="w-full md:w-[calc(32%_-_16px)] flex gap-2 flex-col">
    <app-detail-models [asset]="asset"></app-detail-models>
    <div class="mt-2">
      <ngb-accordion #accAddress="ngbAccordion" activeIds="panel-0">
        <ngb-panel id="panel-0">
          <ng-template ngbPanelTitle>
            <label class="text-base font-medium text-black-base">
              {{ 'RegisterService::AssetAttributes' | abpLocalization }}
            </label>
          </ng-template>
          <ng-template ngbPanelContent>
            <app-attributes [asset]="asset"></app-attributes>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>

      <ngb-accordion #accAddress="ngbAccordion">
        <ngb-panel id="panel-0">
          <ng-template ngbPanelTitle>
            <label class="text-base font-medium text-black-base">
              {{ 'RegisterService::More' | abpLocalization }}
            </label>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="flex flex-col !gap-3 w-full">
              <div class="w-full">
                <label class="form-label text-xs" for="asset-condition-score">
                  {{ 'RegisterService::ConditionScore' | abpLocalization }}
                </label>
                <input
                  id="asset-condition-score"
                  [value]="asset?.conditionScore ?? null"
                  class="form-control bg-gray-30 !py-2"
                  maxlength="64"
                  readonly
                />
              </div>

              <div class="w-full">
                <label class="form-label text-xs" for="asset-date-first-in-service">
                  {{ 'RegisterService::DateFirstInService' | abpLocalization }}
                </label>
                <input
                  id="asset-date-first-in-service"
                  [value]="
                    asset?.dateFirstInService
                      ? (asset.dateFirstInService | date : 'dd/MM/yyyy')
                      : null
                  "
                  class="form-control bg-gray-30 !py-2"
                  maxlength="64"
                  readonly
                />
              </div>

              <div class="w-full">
                <label class="form-label text-xs" for="asset-life-expectancy">
                  {{ 'RegisterService::LifeExpectancy' | abpLocalization }}
                </label>
                <input
                  id="asset-life-expectancy"
                  [value]="
                    asset?.lifeExpectancy && asset?.lifeExpectancyUnit
                      ? asset.lifeExpectancy + ' ' + unitLabel[asset.lifeExpectancyUnit]
                      : null
                  "
                  class="form-control bg-gray-30 !py-2"
                  maxlength="64"
                  readonly
                />
              </div>

              <div class="w-full">
                <label class="form-label text-xs" for="asset-expiry-date">
                  {{ 'RegisterService::ExpiryDate' | abpLocalization }}
                </label>
                <input
                  id="asset-expiry-date"
                  [value]="asset?.expiryDate ? (asset.expiryDate | date : 'dd/MM/yyyy') : null"
                  class="form-control bg-gray-30 !py-2"
                  maxlength="64"
                  readonly
                />
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>
  </div>
</div>
